import {Spinner} from "./spinner";
import {Toast} from "../../components/toast/js/toast";

const COOLDOWN_MS = 3000;

function fillCompanyFields($form, company) {
    $.each(company, (field, value) => {
        const input = $form.find(`[name$="[${field}]"]`).get(0);
        if (!input) {
            return;
        }

        input.value = value;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
    });
}

$(() => {
    const spinner = new Spinner();

    $(document).on('click', '.gus-lookup__button', function () {
        const $button = $(this);
        const $form = $button.closest('.address__form');
        const nipInput = $form.find('[name$="[vatIdentificationNumber]"]').get(0);

        if (!/^\d{10}$/.test(nipInput.value)) {
            nipInput.dispatchEvent(new Event('change', {bubbles: true}));
            nipInput.focus();
            return;
        }

        const nip = nipInput.value;
        $button.prop('disabled', true);
        spinner.addSpinner($button);

        $.post($button.data('url'), {nip})
            .done((response) => {
                if (nipInput.value === nip) {
                    fillCompanyFields($form, response.company);
                }
            })
            .fail(() => new Toast('error', $button.data('errorMessage')))
            .always(() => {
                spinner.removeSpinner($button);
                setTimeout(() => $button.prop('disabled', false), COOLDOWN_MS);
            });
    });
});
